import buttonList from '@/components/backoffice/button/list'
import buttonCreate from '@/components/backoffice/button/create'
import buttonShow from '@/components/backoffice/button/show'
import buttonEdit from '@/components/backoffice/button/edit'
import buttonMassEdit from '@/components/backoffice/button/massContingentsEdit.vue'
import buttonMassEditAdmin from '@/components/backoffice/button/massContingentsEditAdmin.vue'
import buttonDelete from '@/components/backoffice/button/delete'
import buttonResend from '@/components/backoffice/button/resend'
import buttonImpersonate from '@/components/backoffice/button/impersonate'
import buttonDisableBooking from '@/components/backoffice/button/disableBooking'
import buttonBack from '@/components/backoffice/button/back.vue'
import buttonImport from '@/components/backoffice/button/import'
import buttonAdd from '@/components/backoffice/button/add'
import buttonEditAdmin from '@/components/backoffice/button/editTravellerAdmin'
import buttonEnable from '@/components/backoffice/button/enable'
import store from '@/store'
import buttonDisableHotelRetrocession from '@/components/backoffice/button/disableHotelRetrocession'
import abstractApi from "@/api/abstractApi";

/**
 * @param name string
 * @param entityName string
 * @param id int|null
 * @param text bool|string
 * @param icon bool|string
 * @param title bool|string
 * @param entity
 * @returns button object
 */
export function createButton (
  name,
  entityName,
  id = null,
  text = true,
  icon = false,
  title = false,
  entity = null
) {
  let props = null
  let ret = {
    name: name,
    route: {
      name: entityName + '_' + name,
      params: { id: id }
    }
  }

  let titleOverride = null
  let iconOverride = null

  switch (name) {
    case 'create': props = buttonCreate.props; break
    case 'list': props = buttonList.props; break
    case 'show': props = buttonShow.props; break
    case 'edit':
      props = buttonEdit.props
      break
    case 'delete':
      props = buttonDelete.props
      ret.deletionData = {
        entityName: entityName,
        entityId: id
      }
      ret.route = null
      break
    case 'resend':
      props = buttonResend.props
      ret.route = null
      ret.resend = true
      break
    case 'impersonate':
      props = buttonImpersonate.props
      ret.route = null
      if (entity) ret.email = getImpersonateEmail(entity)
      break
    case 'disableBooking':
      if (entity.hasOwnProperty('status') && entity.status >= 0) {
        props = buttonDisableBooking.props
        ret.booking = entity.id
        ret.route = null
      } else {
        ret = null
      }
      break
    case 'disableHotelRetrocession':
      props = buttonDisableHotelRetrocession.props
      if (entity.enabled === true) {
        ret.type = 'disable'
      } else {
        ret.type = 'enable'
        iconOverride = 'play'
        titleOverride = '_enable_hotel_retrocession'
      }
      ret.hotelRetrocession = entity.id
      ret.route = null

      break
    case 'massContingentsEditAdmin':
      props = buttonMassEditAdmin.props
      ret.route = null
      ret.massContingentsEditAdmin = true
      ret.hotelId = id
      break
    case 'massContingentsEdit':
      props = buttonMassEdit.props
      ret.route = null
      ret.massContingentsEdit = true
      ret.hotelId = id
      break
    case 'import':
      props = buttonImport.props
      ret.route = null
      ret.import = true
      break
    case 'add':
      props = buttonAdd.props
      ret.route = null
      ret.add = true
      break
    case 'editAdmin':
      props = buttonEditAdmin.props
      if (store.getters['security/isAdmin']) {
        ret.travellerData = {
          entityId: id,
          entity: entity
        }
      }
      ret.route = null
      ret.editAdmin = true
      break
    case 'enable':
      props = buttonEnable.props
      if (store.getters['security/isAdmin']) {
        ret.travellerData = {
          entityId: id,
          entity: entity
        }
      }
      if (entity.hasOwnProperty('enabled') && entity.enabled === false) {
        titleOverride = '_enable'
        iconOverride = 'check'
      }
      ret.route = null
      ret.enable = true
      break
    case 'back':
      props = buttonBack.props
      if (store.getters['security/isHotel']) {
        ret.route = null
        ret.back = true
      }
      break
    default:
      throw new Error('Button name has to be either "create", "list", "show", "edit" or "delete", "resend", "impersonate", "import"')
  }

  if (props) {
    ret.text = text === true ? props.text.default : text === false ? '' : text
    ret.title = titleOverride ? titleOverride : title === true ? props.title.default : title === false ? '' : ret.title
    ret.faClass = iconOverride ? iconOverride : icon === true ? props.faClass.default : icon === false ? '' : ret.icon
    ret.faPosition = props.faPosition.default
    ret.bootstrapClass = props.bootstrapClass.default
  }

  return ret
}

/**
 * Used to retrieve the email of the user to impersonate
 */
function getImpersonateEmail(entity){
  if (entity.hasOwnProperty('hotel_user') && entity.hotel_user != null) {
    return entity.hotel_user.email
  } else {
    return entity.email
  }
}

export function customButton (name, entityName, id = null, text = null, icon = null, title = null, notif = null) {
  let button = createButton(
    name,
    entityName,
    id,
    text !== null,
    icon !== null,
    title !== null
  )

  button.text = text || ''
  button.faClass = icon || ''
  button.title = title || ''
  button.notif = notif || 0

  return button
}

export function parseButtonsPositions (definition, entityName, onlyShow, id = null, entity = null) {
  let ret = {}

  for (let button of definition) {
    if (onlyShow && button.name !== 'show') continue

    if (store.getters['security/isAdmin'] && button.name === 'back') break

    if (button.vPosition === 'head' && button.hPosition !== 'right') {
      throw new Error('Header pages do not accept buttons on : ' + button.hPosition)
    } else {
      if (ret[button.vPosition] === undefined) {
        ret[button.vPosition] = {}
      }

      if (ret[button.vPosition][button.hPosition] === undefined) {
        ret[button.vPosition][button.hPosition] = []
      }

      let btn = createButton(button.name, entityName, id, button.text, button.faClass, button.title, entity)

      ret[button.vPosition][button.hPosition].push(btn)
    }
  }

  return ret
}
